import React from 'react'

export default function EbankingBackstop({ brand }) {
  return (
    <section className="ob-error">
      <h1 className="zb-heading2">
        Please login via {brand.get('name')} online banking or mobile banking
        app
      </h1>

      <div className="zb-card">
        <div className="zb-card-body">
          <p>
            To view the access store, please log in via online banking or your
            banking app.
          </p>
          <p>
            If you’re using the mobile app, double check you’ve got the latest
            version.
          </p>
        </div>
      </div>
    </section>
  )
}
